import { OwcInput, OwcIconButton, OwcListItem, OwcSelectDropdown, OwcList } from '@one/react';
import React from 'react';
import '../../styles.scss';

/**
 * Renders component able to display sublists.
 *
 * @copyright Roche 2025
 * @author Geoffroy Maillol
 */
class SublistSelector extends React.Component {
    /**
     * Constructor 
     * 
     * @param props The properties passed
     */
    constructor(props) {
        super(props);
        this.state = {
          newSublistValue: "",
        };
    }

    handleNewItemChange(value) {
      this.setState({
        newSublistValue: value,
      });
    }

    addSublist() {
      const updatedList = this.props.availableItems;
      const newValue = this.state.newSublistValue;
      if (newValue && newValue.trim() !== "" && !updatedList.includes(newValue)) {
        updatedList.push(newValue);
        this.props.onAddItem(updatedList);
      }
      this.setState({
        newSublistValue: "",
      });
    }

    renderItem(value) {
      return (
        <OwcListItem key={"item" + value} id={"item" + value} value={value}>
          {value}
        </OwcListItem>
      );
    }
  
    /**
     * Renders the controls
     * @returns The JSX of the controls
     */
    render() {
      return (
        <div>
          <OwcSelectDropdown value={this.props.value}
              multiple limit={9} label="Sublist"
              onValueChange={(ev) => this.props.onSelectedValueChanged(ev.detail)}>
            <OwcInput
                placeholder="Enter a new sublist..."
                value={this.state.newSublistValue}
                onValueChange={(ev) => this.handleNewItemChange(ev.detail)}>
              <OwcIconButton slot="suffix" icon="circle_add" onClick={() => this.addSublist()}/>
            </OwcInput>
            <OwcList>
              {this.props.availableItems.map(sublist => this.renderItem(sublist))}
            </OwcList>
          </OwcSelectDropdown>
        </div>
        
      )
    }
}

export default SublistSelector;
